import { Component, Vue } from 'vue-property-decorator'
import { menuBtn } from '@/utils/menu_level2_button'
import { formatDate } from '@/utils/timeFilter'
import { getMessageReviewById, setMessageReviewUserByMessageReviewId } from '@/api/message'
import { setFinanceOrderStatus, getProjectList } from '@/api/financial-center'
import { Loading } from 'element-ui'
// import { get } from '@/api/financial-center'

@Component({})
export default class OrderInfo extends Vue {

    infoData: any = {}
    reviewId: number;
    logShow = true
    withdrawalDialogShow = false // 撤回审批弹框
    reviewIdea = '' // 审批意见
    reviewDialogShow = false // 审批意见弹框
    status: string
    approvalStatus: number = null
    type = ''
    editFileList: { file: string; cnFile: string; isRequired: string }[] = []
    editFiles = {
        projectAllId: null,
        souCoursePrice: null,
        discountPrice: null,
        price: null,
        haveIPQ: null,
        remark: null,
        priceOrRatio: null,
        isCredit: null,
        dissertationType: null,
        contractNo: null,
    }


    isRequired = false

    disBtn = false
    editFileRequired = false
    types = '' // 审批提交还是抄送类型
    addSignShow = false
    transferShow = false
    approvalVisible = false
    stepNode = {
        isFirstNode: false,
        isSyncEkuaibao: false,
        isSyncEqianbao: false,
    }
    nodeType: string = null //驳回到哪个节点
    isSync: string = null //重新提交后触发E签宝/易快报
    approvedVisible = false // 审批通过
    approvedData = {
        isReturn: 1
    }
    isAgreeRevoke = '' // 审批通过是否允许提交人撤回
    backMoneyUrl = ''
    contractUrl = ''
    fileList = []
    loading = false
    isNotReject = false

    created() {
        this.reviewId = Number(this.$route.query.id)
        this.type = this.$route.query.type ? this.$route.query.type as string : ''
        this.types = this.$route.query.types ? this.$route.query.types as string : ''
        this.status = this.$route.query.status as string
        this.getData()
    }

    menuBtn = menuBtn
    formatDate = formatDate

    get elImageUrls() {
        return this.infoData ? this.fileList.map(item => item.url): []
    }

    async getData() {
        this.loading = true
        await getMessageReviewById(this.reviewId,this.types).then((data: any)=>{
            this.infoData = data.result
            this.isNotReject = data.result.isNotReject == true ? false : true
            this.contractUrl =  this.infoData.contractUrl
            this.fileList = [{name:'回款凭证',url: this.infoData.backMoneyUrl}]
            this.editFileList = this.infoData.editFileList || []
            this.editFileList.forEach(item => {
                this.editFiles[item.file] = this.infoData[item.file]
            })
            if(this.editFileList && this.editFileList.length > 0) this.isRequired = this.type === '0' ? this.editFileList[0].isRequired === '1' ? true : false : false // 判断当前是查看还是审批，判断科比那集字段是否必填

            this.stepNode.isFirstNode = this.infoData.isFirstNode
            this.stepNode.isSyncEkuaibao = this.infoData.isSyncEkuaibao
            this.stepNode.isSyncEqianbao = this.infoData.isSyncEqianbao
            this.loading = false
        }).catch(err=>{
            this.loading = false
        })

    }

    previewContractUrl() {
        window.open(this.contractUrl, 'blank')
    }

    fileExtension(type) {
        return type.substring(type.lastIndexOf('.') + 1)
    }


    // 验证当前字段是否可以编辑
    editFileShow(key: string) {
        if (this.status !== '0' || this.type !== '0') return false
        return this.editFileList.some(item => item.file === key)
    }


    // 撤回审批
    async cancelApproval() {
        await setFinanceOrderStatus({ id: this.infoData.id, action: '1' })
        this.$message.success('撤销审批成功')
        setTimeout(() => {
            window.close()
        }, 1500);
        this.withdrawalDialogShow = false
    }

    // 驳回审批
    clickRejectButton(status: number) {
        this.$set(this.stepNode, 'status', status)
        this.$set(this.stepNode, 'approveId', this.reviewId)
        // this.$set(this.stepNode, 'isSync', true)
        this.approvalVisible = true
    }
    //通过审批
    clickExamineApproveButton(status: number) {
        this.$set(this.approvedData, 'status', status)
        this.$set(this.approvedData, 'approveId', this.reviewId)
        this.$set(this.approvedData, 'editFiles', this.editFiles)
        this.$set(this.approvedData, 'editFileList', this.editFileList)
        this.$set(this.approvedData, 'isRequired', this.isRequired)
        // this.$set(this.approvedData, 'isSync', true)
        this.approvedVisible = true
    }

    // 关闭审批意见弹框
    closeReviewDialog() {
        this.reviewIdea = ''
        this.reviewDialogShow = false
    }

    // 审批意见确认
    // confirmReviewDialog() {
    //
    //     const newObj = this.editFiles
    //     for (const key in newObj) {
    //         if (!this.editFileList.some(item => item.file === key)) {
    //             delete newObj[key]
    //         }
    //     }
    //     if(this.isRequired) {
    //         for(const key in newObj) {
    //             if(!newObj[key] || newObj[key].length === 0) {
    //                 this.editFileRequired = true
    //                 break;
    //             } else {
    //                 this.editFileRequired = false
    //             }
    //         }
    //     }
    //     if(this.editFileRequired && this.approvalStatus === 1) {
    //         this.$message.error('请将编辑的信息填写完整')
    //         return
    //     }
    //     const obj = {
    //         messageReviewId: this.reviewId,
    //         status: this.approvalStatus,
    //         opinion: this.reviewIdea,
    //         form: this.approvalStatus ? newObj : {},
    //         nodeType: this.nodeType,
    //
    //     }
    //     this.disBtn = true;
    //     const loading = Loading.service({
    //         text: `审批${this.approvalStatus === 1 ? '通过中' : '驳回中'}，请稍后`
    //     })
    //     setMessageReviewUserByMessageReviewId(obj).then(() => {
    //         this.$message.success(this.approvalStatus === 1 ? '审批通过' : '审批驳回')
    //         this.reviewIdea = ''
    //         this.reviewDialogShow = false
    //         loading.close();
    //         setTimeout(() => {
    //             window.close()
    //         }, 1500)
    //     }).catch((err: Error) => {
    //         console.log(err)
    //         this.disBtn = false;
    //     })
    // }

    // approvedConfirm() {
    //
    //     const newObj = this.editFiles
    //     for (const key in newObj) {
    //         if (!this.editFileList.some(item => item.file === key)) {
    //             delete newObj[key]
    //         }
    //     }
    //     if(this.isRequired) {
    //         for(const key in newObj) {
    //             if(!newObj[key] || newObj[key].length === 0) {
    //                 this.editFileRequired = true
    //                 break;
    //             } else {
    //                 this.editFileRequired = false
    //             }
    //         }
    //     }
    //     if(this.editFileRequired && this.approvalStatus === 1) {
    //         this.$message.error('请将编辑的信息填写完整')
    //         return
    //     }
    //     const obj = {
    //         messageReviewId: this.reviewId,
    //         status: this.approvalStatus,
    //         opinion: this.reviewIdea,
    //         form: this.approvalStatus ? newObj : {},
    //         isRevoke: this.isAgreeRevoke
    //     }
    //     this.disBtn = true;
    //     const loading = Loading.service({
    //         text: `审批${this.approvalStatus === 1 ? '通过中' : '驳回中'}，请稍后`
    //     })
    //     for(const key in obj) {
    //         if(obj[key].length === 0 || !obj[key]) {
    //             delete obj[key]
    //         }
    //     }
    //     setMessageReviewUserByMessageReviewId(obj).then(() => {
    //         this.$message.success(this.approvalStatus === 1 ? '审批通过' : '审批驳回')
    //         this.reviewIdea = ''
    //         this.reviewDialogShow = false
    //         loading.close();
    //         setTimeout(() => {
    //             window.close()
    //         }, 1500)
    //     }).catch((err: Error) => {
    //         console.log(err)
    //         this.disBtn = false;
    //     })
    // }
//     关闭审批弹框
    handleApprovalClose() {
        this.approvalVisible = false
    }

//    驳回弹框确认
    doApprovalConfirm(data) {
        // this.nodeType = data.rejectNode
        // this.reviewIdea = data.reviewIdea
        // this.isSync = data.isTouchE
        // this.approvalVisible = false
        // this.confirmReviewDialog()
        this.approvalVisible = false
    }

    // 审批通过弹框取消
    handleApprovedClose(){
        this.approvedVisible = false
    }
    // 审批通过弹框确认
    doApprovedConfirm(data) {
        // this.reviewIdea = data.reviewIdea
        // this.isAgreeRevoke = data.isAgreeRevoke
        // this.approvedVisible = false
        // this.approvedConfirm()
        this.approvedVisible = false
    }


    /*
    * 关闭转交弹框*/
    closeTransfer() {
        this.transferShow = false
    }

    /*
    * 转交弹框确认*/
    confirmTransfer() {
        this.transferShow = false
    }

    /*
    * 关闭加签*/
    closeAddSign() {
        this.addSignShow = false
    }

    /*
    * 确认加签*/
    confirmAddSign() {
        this.addSignShow = false
    }
}
